import { from, Observable, of } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { mergeMap, switchMap, withLatestFrom } from 'rxjs';
import { cartVariantAndId } from 'src/core/state/cart';
import { catchable } from 'swagger/utils/ajax-helpers';
import { CartVariant } from 'src/core/state/cart';
import { execute } from 'swagger/ts/WorkwearExpressCustomisationPlatformFrontendItemCustomisationRepositoryV1DeleteCustomisationsPost';
import { execute as guestRemove } from 'swagger/ts/WorkwearExpressCustomisationPlatformFrontendItemCustomisationRepositoryV1DeleteGuestCustomisationsPost';
import { Deps } from 'src/types/global-types';
import { CartMsg } from 'src/core/state/cart';

import { Actions, BasketMsg, TypeMap } from '../basket.actions';

export function removeCustomisationEpic(
    action$: Observable<any>,
    state$: Observable<any>,
    deps: Deps,
): Observable<any> {
    return action$.pipe(
        ofType<Actions, TypeMap['Basket.RemoveCustomisations']>('Basket.RemoveCustomisations'),
        withLatestFrom(cartVariantAndId(state$)),
        switchMap(([{ payload }, [variant, cartId]]) => {
            const output = {
                removeCustomisations: payload.map((item) => {
                    return {
                        customisationId: item.customisation_id,
                        itemId: item.item_id,
                        locationName: item.location_name,
                    } as any;
                }),
            };

            const ajax$ =
                variant === CartVariant.Account
                    ? execute(output, deps)
                    : guestRemove({ cartId: String(cartId) }, output, deps);

            return ajax$.pipe(
                mergeMap(() => {
                    return from([
                        BasketMsg('Basket.RemoveCustomisationsSuccess'),
                        CartMsg('Cart.Refresh', { force: true }),
                        BasketMsg('Basket.Refresh'),
                    ]);
                }),
                catchable(({ error }) => {
                    return of(BasketMsg('Basket.RemoveCustomisationsError', error));
                }),
            );
        }),
    );
}
